class FeaturedReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.featured-reviews__track');
    this.cards = Array.from(this.querySelectorAll('.featured-reviews__card'));
    this.dots = Array.from(this.querySelectorAll('.featured-reviews__dot'));

    if (!this.track || this.cards.length === 0 || this.dots.length === 0) return;

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: this.track,
      threshold: 0.6,
    });

    this.cards.forEach((card) => this.observer.observe(card));
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const index = this.cards.indexOf(entry.target);
      if (index === -1) return;
      this.setActiveDot(index);
    });
  }

  setActiveDot(activeIndex) {
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('featured-reviews__dot--active', index === activeIndex);
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('featured-reviews-carousel')) {
  customElements.define('featured-reviews-carousel', FeaturedReviewsCarousel);
}
